import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ServicePageLayout from '../components/ServicePageLayout';
import { getServiceData } from '../data/serviceData';

const GenericService = () => {
  const params = useParams();
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  // Extract category and slug from URL
  const slug = params.service || params.type || '';
  const category = pathParts.length >= 2 ? pathParts[1] : 'trademark';

  const data = getServiceData(category, slug);

  return <ServicePageLayout data={data} />;
};

export default GenericService;
